import React from "react";
import { useTranslation } from "react-i18next";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";
import { CheckboxIcon } from "@aureskonnect/react-ui";

import { store } from "@components/VerticalLayout/store";
import {
    setIsHistoryShopsModalOpened,
    setSelectedPaymentMethods,
    setShopsNumberActive,
    setShopsNumberArchived,
    setShopsPaymentMethodsData,
    setShopsSelectedRow,
    store as dataStore,
    setLocalShop,
    setAssociatedPaymentMethods,
    setIsLoading,
    setGlobalDataIsUpdated,
} from "../store";
import { generalConfigStore, setItemsDisable } from "@store";
import { store as StoreConfirmationActivationDeactivation } from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";

import { removeArrayOfObjectsDuplicates } from "@helpers/general";

import { CustomSideFilter } from "./CustomSideFilter";
import { PaymentModalAssociateModal } from "./PaymentModalAssociateModal";
import HistoryModal from "../HistoryModal";
import { ConfirmationActivationDeactivationMessageModal } from "@components/Common/ConfirmationActivationDeactivationMessageModal";
import { ArchivedValidationModal } from "@components/Common/ArchivedValidationModal";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { arrayOfCustomColumns } from "./hooks";
import ModalLoading from "@components/Common/ModalLoading";
import { useAuthHeader } from "../../../../api/headersKeycloak";
import { useFetchGlobal } from "../../../../api/hooks";

type ShopsPaymentMethodType = {
    isArchivedPaymentMethodsClicked: boolean;
    setIsArchivedPaymentMethodsClicked: Function;
};
export default function ShopsPaymentMethod({
    isArchivedPaymentMethodsClicked,
    setIsArchivedPaymentMethodsClicked,
}: ShopsPaymentMethodType) {
    const { franchiseID, userID, oneShop, operatorID } = useSnapshot(store);
    const {
        isHistoryShopsModalOpened,
        key,
        isLoading,
        globalDataIsUpdated,
    } = useSnapshot(dataStore);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const { activationDeactivationMessageModalOpened } = useSnapshot(
        StoreConfirmationActivationDeactivation
    );
    const getAuthHeader = useAuthHeader();
    const uuidUser = localStorage.getItem("uuidUser");
    const { t } = useTranslation();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { fetchGlobal } = useFetchGlobal();
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [isShopSelected, setIsShopSelected] = React.useState<boolean>(false);
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [isAssociateModalOpened, setIsAssociateModalOpened] = React.useState<
        boolean
    >(false);
    const [data, setData] = React.useState<any>({});
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    const [
        isArchivedValidationModalOpened,
        setIsArchivedValidationModalOpened,
    ] = React.useState<boolean>(false);
    let urlArchive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod?userId=${userID}&franchiseId=${franchiseID}&type=archived&uuidUser=${uuidUser}`;
    let urlActive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod?userId=${userID}&franchiseId=${franchiseID}&type=activated&uuidUser=${uuidUser}`;

    async function handleArchivePaymentMethod(selectedRowData: any) {
        setIsLoading(true);
        let dataConfig = {
            userId: userID,
            shopId: [selectedRowData.idShop],
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: {
                [selectedRowData.id]: {
                    designation: selectedRowData[t("Payment method")],
                    currency: selectedRowData.Devise,
                    display: selectedRowData[t("Display name")],
                    shopId: [selectedRowData.idShop],
                    saleSupport: selectedRowData[t("Support de vente")],
                    country: selectedRowData.Pays,
                    tag: selectedRowData.tag,
                    isActive: false,
                    isArchived: true,
                    languages: selectedRowData.languages,
                    advancedDisplayName: selectedRowData.advancedDisplayName,
                },
            },
        };
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataConfig),
        };
        try {
            await fetchGlobal(apiUrl, requestOptions);
            setGlobalDataIsUpdated(true);
            setIsValidateClicked(false);
            setIsArchivedValidationModalOpened(false);
            setIsLoading(false);
            toast.success(
                `${t("The Payment method is successfully archived")}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                }
            );

            const item = itemsDisable.find(
                (item: any) =>
                    item.id === selectedRows[0].id &&
                    item.shopId === selectedRows[0].idShop
            );
            if (item !== undefined) {
                const item = itemsDisable.filter(
                    (item: any) =>
                        !(
                            item.id === selectedRows[0].id &&
                            item.shopId === selectedRows[0].idShop
                        )
                );
                setItemsDisable(item);
            }
        } catch (error) {
            toast.error(`${t("There's an erroraa")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        let localShop: any[] = [];
        let array: any = [];
        let associatedPaymentMethod: any[] = [];
        let localArchivedPaymentMethod: number = 0;
        let localActivePaymentMethod: number = 0;

        if (selectedRows.length > 0) {
            selectedRows.forEach((element: any) => {
                if (element.Boutique !== undefined) {
                    if (element.Boutique !== "") {
                        localShop.push({
                            id: element.idShop,
                            label: element.Boutique,
                            pays: element.Pays,
                        });
                    }

                    localActivePaymentMethod +=
                        element.paymentMethodsNumber.activated;
                    localArchivedPaymentMethod +=
                        element.paymentMethodsNumber.archived;
                    element.subRows.forEach((el: any) => {
                        array.push({ [el.idShop]: el.id });
                        associatedPaymentMethod.push(el);
                    });
                } else {
                    array.push({ [element.idShop]: element.id });
                }
            });
            setIsShopSelected(localShop.length >= 1);
            setLocalShop(localShop);
            setAssociatedPaymentMethods(associatedPaymentMethod);
            setShopsSelectedRow(selectedRows);
            setSelectedPaymentMethods(removeArrayOfObjectsDuplicates(array));
            if (selectedRows.filter((el: any) => el.Boutique).length > 0) {
                setShopsNumberActive(localActivePaymentMethod);
                setShopsNumberArchived(localArchivedPaymentMethod);
            } else {
                setShopsNumberActive(
                    data.othersData !== undefined
                        ? data.othersData.activated
                        : 0
                );
                setShopsNumberArchived(
                    data.othersData !== undefined ? data.othersData.archived : 0
                );
            }
        } else {
            setShopsNumberActive(
                data.othersData !== undefined ? data.othersData.activated : 0
            );
            setShopsNumberArchived(
                data.othersData !== undefined ? data.othersData.archived : 0
            );
        }
        setShopsPaymentMethodsData(data.data);
    }, [selectedRows, data]);

    React.useEffect(() => {
        if (isValidateClicked) {
            handleArchivePaymentMethod(selectedRows[0]);
        }
        // eslint-disable-next-line
    }, [isValidateClicked, selectedRows]);

    return (
        <React.Fragment>
            <DynamicTable
                key={key}
                requestHeader={{
                    "Accept-Language": i18nextLng,
                    ...getAuthHeader,
                }}
                url={isArchivedPaymentMethodsClicked ? urlArchive : urlActive}
                canExpand
                canSelect
                setData={setData}
                customSelect
                setSelectedRows={setSelectedRows}
                showGlobalFilter
                setLocalFilterActive={setLocalFilterActive}
                filterActive={filterActive}
                canMovedCheckboxLeftOnExpand
                customJsxSideFilterButton={
                    <CustomSideFilter
                        isShopSelected={isShopSelected}
                        selectedRows={selectedRows}
                        setIsAssociateModalOpened={setIsAssociateModalOpened}
                        setLocalFilterActive={setLocalFilterActive}
                        isAssociateModalOpened={isAssociateModalOpened}
                        isArchivedPaymentMethodsClicked={
                            isArchivedPaymentMethodsClicked
                        }
                        setIsArchivedPaymentMethodsClicked={
                            setIsArchivedPaymentMethodsClicked
                        }
                    />
                }
                canResize
                actionColumn={(e: any) => {
                    return e.selectedRow.subRows === undefined ? (
                        <div></div>
                    ) : null;
                }}
                arrayOfCustomColumns={arrayOfCustomColumns({
                    isArchivedPaymentMethodsClicked,
                    isArchivedValidationModalOpened,
                    setIsArchivedValidationModalOpened,
                    setSelectedRows,
                })}
                setDataIsUpdated={
                    setGlobalDataIsUpdated as
                        | React.Dispatch<React.SetStateAction<number | boolean>>
                        | undefined
                }
                dataIsUpdated={globalDataIsUpdated}
                showFilter
                elevationTable={1}
                minHeight={oneShop ? "500px" : "450px"}
                maxHeight={oneShop ? "500px" : "450px"}
                name="Choice"
            />
            {isAssociateModalOpened ? (
                <PaymentModalAssociateModal
                    selectedShopsRows={selectedRows}
                    setIsAssociateModalOpened={setIsAssociateModalOpened}
                    isAssociateModalOpened={isAssociateModalOpened}
                />
            ) : null}

            {isHistoryShopsModalOpened ? (
                <HistoryModal
                    ids={selectedRows}
                    setIsModalOpened={setIsHistoryShopsModalOpened}
                    isModalOpened={isHistoryShopsModalOpened}
                />
            ) : null}
            {activationDeactivationMessageModalOpened && !oneShop && (
                <ConfirmationActivationDeactivationMessageModal />
            )}
            {isLoading ? (
                <ModalLoading
                    isOpen={isLoading}
                    data={{
                        title: t("Alert"),
                        message: t("The action is currently being processed."),
                    }}
                />
            ) : null}
            {isArchivedValidationModalOpened ? (
                <ArchivedValidationModal
                    text={t(
                        "Attention, this (these) payment method can be used by other modules.\n\nDo you want to confirm the archiving of the selected of payment method(s)"
                    )}
                    isModalOpened={isArchivedValidationModalOpened}
                    setIsModalOpened={setIsArchivedValidationModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
        </React.Fragment>
    );
}
